module.exports = __webpack_public_path__ + "static/media/retail-property-grid-3.38d2d4ee.jpeg";